/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/document/DocumentScannerTextLocalization.yaml
import { PartiallyConstructible } from '../../utils/utils';
/**
Configuration of all the strings for the standalone cropping screen.
*/
export class DocumentScannerTextLocalization extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<DocumentScannerTextLocalization>`} */
    constructor(source = {}) {
        super();
        /**
          The 'cancel' button title, located in the top bar of the camera screen and the reorder pages screen.
          
          Default is "Cancel"
          */
        this.cameraTopBarCancelButtonTitle = 'Cancel';
        /**
          The title of the camera screen, located in the top bar.
          
          Default is "Scan Document"
          */
        this.cameraTopBarTitle = 'Scan Document';
        /**
          The text for the static user guidance, located just below the top bar of the camera screen.
          
          Default is "Scan each page of your document."
          */
        this.cameraTopGuidance = 'Scan each page of your document.';
        /**
          The user guidance text that is initially displayed, before a document is detected.
          
          Default is "Please hold your device over a document."
          */
        this.cameraUserGuidanceStart = 'Please hold your device over a document.';
        /**
          The user guidance text displayed when no document is found.
          
          Default is "No document found"
          */
        this.cameraUserGuidanceNoDocumentFound = 'No document found';
        /**
          The user guidance text displayed a detected documents aspect ratio is not within the acceptable range.
          
          Default is "Bad aspect ratio"
          */
        this.cameraUserGuidanceBadAspectRatio = 'Bad aspect ratio';
        /**
          The user guidance text displayed when a landscape document is detected when the camera is in portrait mode (and vice versa).
          
          Default is "Orientation mismatch"
          */
        this.cameraUserGuidanceOrientationMismatch = 'Orientation mismatch';
        /**
          The user guidance text displayed when the document pitch/skew angle is unacceptable.
          
          Default is "Bad angles"
          */
        this.cameraUserGuidanceBadAngles = 'Bad angles';
        /**
          The user guidance text displayed when the background is too noisy.
          
          Default is "Its too noisy. Try another background for the document"
          */
        this.cameraUserGuidanceTooNoisy = 'Its too noisy. Try another background for the document';
        /**
          The user guidance text displayed when the document is not centered in the finder view.
          
          Default is "Document is off center"
          */
        this.cameraUserGuidanceTextHintOffCenter = 'Document is off center';
        /**
          The user guidance text displayed when the document is too far from camera.
          
          Default is "Document is too small. Move camera closer."
          */
        this.cameraUserGuidanceTooSmall = 'Document is too small. Move camera closer.';
        /**
          The user guidance text displayed when it is too dark to capture an adequate image.
          
          Default is "Its too dark. Add more light."
          */
        this.cameraUserGuidanceTooDark = 'Its too dark. Add more light.';
        /**
          The user guidance text displayed when the device is in energy saving mode. iOS only.
          
          Default is "Energy save mode is on"
          */
        this.cameraUserGuidanceEnergySaveMode = 'Energy save mode is on';
        /**
          The user guidance text displayed when the document is ready to be captured in 'auto snapping' mode.
          
          Default is "Hold still capturing..."
          */
        this.cameraUserGuidanceReadyToCapture = 'Hold still capturing...';
        /**
          The user guidance text displayed when the document is ready to be captured in 'manual snapping' mode.
          
          Default is "Ready to capture!"
          */
        this.cameraUserGuidanceReadyToCaptureManual = 'Ready to capture!';
        /**
          The 'import image' button title, located in the bottom bar of the camera screen.
          
          Default is "Import"
          */
        this.cameraImportButtonTitle = 'Import';
        /**
          The 'flashlight on' button title, located in the bottom bar of the camera screen.
          
          Default is "On"
          */
        this.cameraTorchOnButtonTitle = 'On';
        /**
          The 'flashlight off' button title, located in the bottom bar of the camera screen.
          
          Default is "Off"
          */
        this.cameraTorchOffButtonTitle = 'Off';
        /**
          The 'auto snapping' mode button title, located in the bottom bar of the camera screen.
          
          Default is "Auto"
          */
        this.cameraAutoSnapButtonTitle = 'Auto';
        /**
          The 'manual snapping' mode button title, located in the bottom bar of the camera screen.
          
          Default is "Manual"
          */
        this.cameraManualSnapButtonTitle = 'Manual';
        /**
          The 'preview' button title, located in the bottom bar of the camera screen. '%d' denotes the total number of captured pages.
          
          Default is "%d Pages"
          */
        this.cameraPreviewButtonTitle = '%d Pages';
        /**
          The 'done' button title of the introduction screen, located in the top bar.
          
          Default is "Done"
          */
        this.cameraIntroDoneButton = 'Done';
        /**
          The title of the introduction screen, located in the top bar.
          
          Default is "How to scan a document"
          */
        this.cameraIntroTitle = 'How to scan a document';
        /**
          The subtitle of the introduction screen.
          
          Default is "Follow the steps below to create a high-quality document scan"
          */
        this.cameraIntroSubtitle = 'Follow the steps below to create a high-quality document scan';
        /**
          The first scanning step text of the introduction screen.
          
          Default is "1. Place your document on a flat surface."
          */
        this.cameraIntroItem1 = '1. Place your document on a flat surface.';
        /**
          The second scanning step text of the introduction screen.
          
          Default is "2. Hold your phone above the document."
          */
        this.cameraIntroItem2 = '2. Hold your phone above the document.';
        /**
          The third scanning step text of the introduction screen.
          
          Default is "3. Follow the on-screen guidance to find the optimal position."
          */
        this.cameraIntroItem3 = '3. Follow the on-screen guidance to find the optimal position.';
        /**
          The fourth scanning step text of the introduction screen.
          
          Default is "4. Once you reach the optimal position, you can manually scan the document or let the app scan it automatically."
          */
        this.cameraIntroItem4 = '4. Once you reach the optimal position, you can manually scan the document or let the app scan it automatically.';
        /**
          The progress overlay title that is displayed on the camera screen during processing.
          
          Default is "Please wait..."
          */
        this.cameraProgressOverlayTitle = 'Please wait...';
        /**
          The title of the cancel camera screen alert dialog.
          
          Default is "Cancel?"
          */
        this.cameraCancelAlertTitle = 'Cancel?';
        /**
          The subtitle of the cancel camera screen alert dialog.
          
          Default is "Canceling will delete all the pages scanned so far. Are you sure you want to cancel?"
          */
        this.cameraCancelAlertSubtitle = 'Canceling will delete all the pages scanned so far. Are you sure you want to cancel?';
        /**
          The 'no' button title of the cancel camera screen alert dialog.
          
          Default is "No"
          */
        this.cameraCancelNoButtonTitle = 'No';
        /**
          The 'yes' button title of the cancel camera screen alert dialog.
          
          Default is "Yes, Cancel"
          */
        this.cameraCancelYesButtonTitle = 'Yes, Cancel';
        /**
          The title of the page limit reached alert dialog.
          
          Default is "You reached the limit!"
          */
        this.cameraLimitReachedAlertTitle = 'You reached the limit!';
        /**
          The subtitle of the page limit reached alert dialog.
          
          Default is "You have scanned the maximum number of pages and cannot add any more. Please delete at least one page to perform a new scan."
          */
        this.cameraLimitReachedAlertSubtitle = 'You have scanned the maximum number of pages and cannot add any more. Please delete at least one page to perform a new scan.';
        /**
          The 'OK' button title of the page limit reached alert dialog.
          
          Default is "Ok"
          */
        this.cameraLimitReachedOkButtonTitle = 'Ok';
        /**
          The hint text of the acknowledgement screen explaining that the quality of the scanned page is unacceptable.
          
          Default is "The quality of your scan does not seem sufficient."
          */
        this.acknowledgementScreenBadDocumentHint = 'The quality of your scan does not seem sufficient.';
        /**
          The 'retake' button title of the acknowledgement screen.
          
          Default is "Retake"
          */
        this.acknowledgementRetakeButtonTitle = 'Retake';
        /**
          The 'accept' button title of the acknowledgement screen.
          
          Default is "Use Scan"
          */
        this.acknowledgementAcceptButtonTitle = 'Use Scan';
        /**
          The title of the review screen, located in the top bar. '%d' denotes the total number of captured pages.
          
          Default is "Review (%d)"
          */
        this.reviewScreenTitle = 'Review (%d)';
        /**
          The 'back' button title, located in the top bar of the review screen.
          
          Default is "Back"
          */
        this.reviewTopBarBackButtonTitle = 'Back';
        /**
          The page count label text. The first occurrence of '%d' denotes the current page number, while the second occurrence of '%d' denotes the total number of captured pages.
          
          Default is "Page %d/%d"
          */
        this.reviewScreenPageCount = 'Page %d/%d';
        /**
          The 'add' button title, located in the bottom bar of the review screen.
          
          Default is "Add"
          */
        this.reviewScreenAddButtonTitle = 'Add';
        /**
          The 'retake' button title, located in the bottom bar of the review screen.
          
          Default is "Retake"
          */
        this.reviewScreenRetakeButtonTitle = 'Retake';
        /**
          The 'crop' button title, located in the bottom bar of the review screen.
          
          Default is "Crop"
          */
        this.reviewScreenCropButtonTitle = 'Crop';
        /**
          The 'rotate' button title, located in the bottom bar of the review screen.
          
          Default is "Rotate"
          */
        this.reviewScreenRotateButtonTitle = 'Rotate';
        /**
          The 'delete' button title, located in the bottom bar of the review screen.
          
          Default is "Delete"
          */
        this.reviewScreenDeleteButtonTitle = 'Delete';
        /**
          The 'submit' button title, located in the bottom bar of the review screen.
          
          Default is "Submit"
          */
        this.reviewScreenSubmitButtonTitle = 'Submit';
        /**
          The 'delete all' menu button title, accessed via the 'more' button of the review screen.
          
          Default is "Delete all"
          */
        this.reviewScreenDeleteAllButtonTitle = 'Delete all';
        /**
          The 'reorder pages' menu button title, accessed via the 'more' button of the review screen.
          
          Default is "Reorder pages"
          */
        this.reviewScreenReorderPagesButtonTitle = 'Reorder pages';
        /**
          The 'close' button title of the zoom overlay for the review screen.
          
          Default is "Close"
          */
        this.zoomOverlayCancelButtonText = 'Close';
        /**
          The title of the delete page alert dialog for the review screen.
          
          Default is "Delete page?"
          */
        this.reviewDeletePageAlertTitle = 'Delete page?';
        /**
          The title of the delete all pages alert dialog for the review screen.
          
          Default is "Delete all?"
          */
        this.reviewDeleteAllPagesAlertTitle = 'Delete all?';
        /**
          The subtitle of the delete page alert dialog for the review screen.
          
          Default is "Are you sure you want to delete the page?"
          */
        this.reviewDeletePageAlertSubTitle = 'Are you sure you want to delete the page?';
        /**
          The subtitle of the delete all pages alert dialog for the review screen.
          
          Default is "Are you sure you want to delete all pages?"
          */
        this.reviewDeleteAllPagesAlertSubtitle = 'Are you sure you want to delete all pages?';
        /**
          The 'confirm' button title of the delete page alert dialog for the review screen.
          
          Default is "Yes, Delete"
          */
        this.reviewDeletePageAlertConfirmButtonTitle = 'Yes, Delete';
        /**
          The 'confirm' button title of the delete all pages alert dialog for the review screen.
          
          Default is "Yes, Delete all"
          */
        this.reviewDeleteAllPagesAlertDeleteButtonTitle = 'Yes, Delete all';
        /**
          The 'delete and retake' button title of the delete page alert dialog for the review screen.
          
          Default is "Delete and Retake"
          */
        this.reviewDeletePageAlertDeleteRetakeButtonTitle = 'Delete and Retake';
        /**
          The 'cancel' button title of the delete page alert dialog for the review screen.
          
          Default is "Cancel"
          */
        this.reviewDeletePageAlertCancelButtonTitle = 'Cancel';
        /**
          The 'cancel' button title of the delete all pages alert dialog for the review screen.
          
          Default is "Cancel"
          */
        this.reviewDeleteAllPagesAlertCancelButtonTitle = 'Cancel';
        /**
          The title of the acknowledgement screen, located in the top bar.
          
          Default is "Acknowledgement"
          */
        this.acknowledgementTitle = 'Acknowledgement';
        /**
          The title of the reorder pages screen, located in the top bar.
          
          Default is "Reorder Pages"
          */
        this.reorderPageTitle = 'Reorder Pages';
        /**
          The text for the static user guidance, located just below the top bar of the reorder pages screen.
          
          Default is "Drag pages to reorder"
          */
        this.reorderPageGuidanceTitle = 'Drag pages to reorder';
        /**
          The title below each page object of the reorder pages screen. '%d' denotes the current page number.
          
          Default is "%d"
          */
        this.reorderPageText = '%d';
        /**
          The 'confirm' button title, located in the top bar of the reorder pages screen.
          
          Default is "Done"
          */
        this.reorderTopBarConfirmButtonTitle = 'Done';
        /**
          The 'cancel' button title, located in the top bar of the reorder pages screen.
          
          Default is "Cancel"
          */
        this.reorderTopBarCancelButtonTitle = 'Cancel';
        /**
          The 'confirm' button title, located in the top bar of the cropping screen.
          
          Default is "Done"
          */
        this.croppingTopBarConfirmButtonTitle = 'Done';
        /**
          The 'cancel' button title, located in the top bar of the cropping screen.
          
          Default is "Cancel"
          */
        this.croppingTopBarCancelButtonTitle = 'Cancel';
        /**
          The 'detect document' button title, located in the bottom bar of the cropping screen.
          
          Default is "Detect"
          */
        this.croppingDetectButtonTitle = 'Detect';
        /**
          The 'rotate page' button title, located in the bottom bar of the cropping screen.
          
          Default is "Rotate"
          */
        this.croppingRotateButtonTitle = 'Rotate';
        /**
          The 'reset detection' button title, located in the bottom bar of the cropping screen.
          
          Default is "Reset"
          */
        this.croppingResetButtonTitle = 'Reset';
        /**
          The title of the cropping screen, located in the top bar.
          
          Default is "Crop"
          */
        this.croppingScreenTitle = 'Crop';
        /**
          The accessibility hint for the 'introduction' button, located in the top bar of the camera screen.
          
          Default is "Tap to open introduction screen"
          */
        this.accessibilityDescriptionCameraTopBarIntroButton = 'Tap to open introduction screen';
        /**
          The accessibility hint for the 'cancel' button, located in the top bar of the camera screen.
          
          Default is "Tap to close scanner screen"
          */
        this.accessibilityDescriptionCameraTopBarCancelButton = 'Tap to close scanner screen';
        /**
          The accessibility hint for the 'import image' button, located in the bottom bar of the camera screen.
          
          Default is "Tap to import image"
          */
        this.accessibilityDescriptionCameraImportButton = 'Tap to import image';
        /**
          The accessibility hint for the 'flashlight on' button, located in the bottom bar of the camera screen.
          
          Default is "Tap to disable torch"
          */
        this.accessibilityDescriptionCameraTorchOnButton = 'Tap to disable torch';
        /**
          The accessibility hint for the 'flashlight off' button, located in the bottom bar of the camera screen.
          
          Default is "Tap to enable torch"
          */
        this.accessibilityDescriptionCameraTorchOffButton = 'Tap to enable torch';
        /**
          The accessibility hint for the 'shutter' button, located in the bottom bar of the camera screen.
          
          Default is "Tap to take image"
          */
        this.accessibilityDescriptionCameraShutterButton = 'Tap to take image';
        /**
          The accessibility hint for the 'auto snapping' mode button, located in the bottom bar of the camera screen.
          
          Default is "Tap to enable manual snapping mode"
          */
        this.accessibilityDescriptionCameraAutoSnapButton = 'Tap to enable manual snapping mode';
        /**
          The accessibility hint for the 'manual snapping' mode button, located in the bottom bar of the camera screen.
          
          Default is "Tap to enable auto snapping mode"
          */
        this.accessibilityDescriptionCameraManualSnapButton = 'Tap to enable auto snapping mode';
        /**
          The accessibility hint for the 'preview' button, located in the bottom bar of the camera screen.
          
          Default is "Tap to preview scanned pages"
          */
        this.accessibilityDescriptionCameraPreviewButton = 'Tap to preview scanned pages';
        /**
          The accessibility hint for the 'done' button of the introduction screen.
          
          Default is "Tap to close introduction screen"
          */
        this.accessibilityDescriptionCameraIntroDoneButton = 'Tap to close introduction screen';
        /**
          The accessibility hint for the 'retake' button of the acknowledgement screen.
          
          Default is "Tap to retake the image"
          */
        this.accessibilityDescriptionAcknowledgementRetakeButton = 'Tap to retake the image';
        /**
          The accessibility hint for the 'accept' button of the acknowledgement screen.
          
          Default is "Tap to accept the image regardless of its quality"
          */
        this.accessibilityDescriptionAcknowledgementAcceptButton = 'Tap to accept the image regardless of its quality';
        /**
          The accessibility hint for the 'confirm' button, located in the top bar of the cropping screen.
          
          Default is "Tap to apply changes"
          */
        this.accessibilityDescriptionCroppingTopBarConfirmButton = 'Tap to apply changes';
        /**
          The accessibility hint for the 'cancel' button, located in the top bar of the cropping screen.
          
          Default is "Tap to close screen without applying changes"
          */
        this.accessibilityDescriptionCroppingTopBarCancelButton = 'Tap to close screen without applying changes';
        /**
          The accessibility hint for the 'detect document' button, located in the bottom bar of the cropping screen.
          
          Default is "Tap to detect document on the image"
          */
        this.accessibilityDescriptionCroppingDetectButton = 'Tap to detect document on the image';
        /**
          The accessibility hint for the 'rotate page' button, located in the bottom bar of the cropping screen.
          
          Default is "Tap to rotate document"
          */
        this.accessibilityDescriptionCroppingRotateButton = 'Tap to rotate document';
        /**
          The accessibility hint for the 'reset detection' button, located in the bottom bar of the cropping screen.
          
          Default is "Tap to reset document contour to whole image"
          */
        this.accessibilityDescriptionCroppingResetButton = 'Tap to reset document contour to whole image';
        /**
          The accessibility hint for the 'confirm' button, located in the top bar of the reorder pages screen.
          
          Default is "Tap to apply changes"
          */
        this.accessibilityDescriptionReorderTopBarConfirmButton = 'Tap to apply changes';
        /**
          The accessibility hint for the 'cancel' button, located in the top bar of the reorder pages screen.
          
          Default is "Tap to close screen without applying changes"
          */
        this.accessibilityDescriptionReorderTopBarCancelButton = 'Tap to close screen without applying changes';
        /**
          The accessibility hint for the 'next page' button of the review screen.
          
          Default is "Tap to switch to the new page"
          */
        this.accessibilityDescriptionReviewNextPageButton = 'Tap to switch to the new page';
        /**
          The accessibility hint for the 'previous page' button of the review screen.
          
          Default is "Tap to switch to the previous page"
          */
        this.accessibilityDescriptionReviewPreviousPageButton = 'Tap to switch to the previous page';
        /**
          The accessibility hint for the 'add' button, located in the bottom bar of the review screen.
          
          Default is "Tap to Add new page"
          */
        this.accessibilityDescriptionReviewAddButton = 'Tap to Add new page';
        /**
          The accessibility hint for the 'retake' button, located in the bottom bar of the review screen.
          
          Default is "Tap to Retake current selected page"
          */
        this.accessibilityDescriptionReviewRetakeButton = 'Tap to Retake current selected page';
        /**
          The accessibility hint for the 'crop' button, located in the bottom bar of the review screen.
          
          Default is "Tap to Crop selected page"
          */
        this.accessibilityDescriptionReviewCropButton = 'Tap to Crop selected page';
        /**
          The accessibility hint for the 'rotate' button, located in the bottom bar of the review screen.
          
          Default is "Tap to Rotate selected page clockwise"
          */
        this.accessibilityDescriptionReviewRotateButton = 'Tap to Rotate selected page clockwise';
        /**
          The accessibility hint for the 'delete' button, located in the bottom bar of the review screen.
          
          Default is "Tap to Delete selected page"
          */
        this.accessibilityDescriptionReviewDeleteButton = 'Tap to Delete selected page';
        /**
          The accessibility hint for the 'submit' button, located in the bottom bar of the review screen.
          
          Default is "Tap to Submit document"
          */
        this.accessibilityDescriptionReviewSubmitButton = 'Tap to Submit document';
        /**
          The accessibility hint for the 'more' button, located in the top bar of the review screen.
          
          Default is "Tap to show additional options"
          */
        this.accessibilityDescriptionReviewMoreButton = 'Tap to show additional options';
        /**
          The accessibility hint for the 'delete all' menu button, accessed via the 'more' button of the review screen.
          
          Default is "Tap to Delete all pages"
          */
        this.accessibilityDescriptionReviewDeleteAllButton = 'Tap to Delete all pages';
        /**
          The accessibility hint for the 'reorder pages' menu button, accessed via the 'more' button of the review screen.
          
          Default is "Tap to Reorder pages"
          */
        this.accessibilityDescriptionReviewReorderPagesButton = 'Tap to Reorder pages';
        /**
          The accessibility hint for the 'close' button of the zoom overlay for the review screen.
          
          Default is "Tap to Close zoom overlay"
          */
        this.accessibilityDescriptionZoomOverlayCancelButton = 'Tap to Close zoom overlay';
        /**
          The accessibility hint for the 'zoom' button of the review screen.
          
          Default is "Tap to open zoom overlay for selected page"
          */
        this.accessibilityDescriptionReviewZoomButton = 'Tap to open zoom overlay for selected page';
        /**
          The accessibility hint for the 'back' button, located in the top bar of the review screen.
          
          Default is "Tap to Close review screen"
          */
        this.accessibilityDescriptionReviewTopBarBackButton = 'Tap to Close review screen';
        /**
          The accessibility hint for the 'confirm' button of the delete page alert dialog for the review screen.
          
          Default is "Tap to Delete page"
          */
        this.accessibilityDescriptionReviewDeletePageAlertConfirmButton = 'Tap to Delete page';
        /**
          The accessibility hint for the 'confirm' button of the delete all pages alert dialog for the review screen.
          
          Default is "Tap to Delete all pages"
          */
        this.accessibilityDescriptionReviewDeleteAllPagesAlertDeleteButton = 'Tap to Delete all pages';
        /**
          The accessibility hint for the 'delete and retake' button of the delete page alert dialog for the review screen.
          
          Default is "Tap to Delete page and Retake it"
          */
        this.accessibilityDescriptionReviewDeletePageAlertDeleteRetakeButton = 'Tap to Delete page and Retake it';
        /**
          The accessibility hint for the 'cancel' button of the delete page alert dialog for the review screen.
          
          Default is "Tap to Cancel operation"
          */
        this.accessibilityDescriptionReviewDeletePageAlertCancelButton = 'Tap to Cancel operation';
        /**
          The accessibility hint for the 'cancel' button of the delete all pages alert dialog for the review screen.
          
          Default is "Tap to Cancel operation"
          */
        this.accessibilityDescriptionReviewDeleteAllPagesAlertCancelButton = 'Tap to Cancel operation';
        /**
          The accessibility hint for the 'OK' button of the page limit reached alert dialog.
          
          Default is "Tap to close alert dialog"
          */
        this.accessibilityDescriptionCameraLimitReachedOkButton = 'Tap to close alert dialog';
        /**
          The accessibility hint for the 'yes' button of the cancel camera screen alert dialog.
          
          Default is "Tap to cancel document"
          */
        this.accessibilityDescriptionCameraCancelYesButton = 'Tap to cancel document';
        /**
          The accessibility hint for the 'no' button of the cancel camera screen alert dialog.
          
          Default is "Tap to close alert dialog"
          */
        this.accessibilityDescriptionCameraCancelNoButton = 'Tap to close alert dialog';
        /**
          The title of the camera permission dialog.
          
          Default is "Camera permission denied!"
          */
        this.cameraPermissionEnableCameraTitle = 'Camera permission denied!';
        /**
          The explanation text of the camera permission dialog.
          
          Default is "Please allow the usage of the camera to start the scanning process."
          */
        this.cameraPermissionEnableCameraExplanation = 'Please allow the usage of the camera to start the scanning process.';
        /**
          The 'enable' button title of the camera permission dialog.
          
          Default is "Grant permission"
          */
        this.cameraPermissionEnableCameraButton = 'Grant permission';
        /**
          The 'close' button title of the camera permission dialog.
          
          Default is "Close"
          */
        this.cameraPermissionCloseButton = 'Close';
        /**
          The accessibility hint for the 'enable' button of the camera permission dialog.
          
          Default is "Tap to grant camera permission"
          */
        this.accessibilityDescriptionCameraPermissionEnableCameraButton = 'Tap to grant camera permission';
        /**
          The accessibility hint for the 'close' button of the camera permission dialog.
          
          Default is "Close screen without granting permission"
          */
        this.accessibilityDescriptionCameraPermissionCloseButton = 'Close screen without granting permission';
        if (source.cameraTopBarCancelButtonTitle !== undefined) {
            this.cameraTopBarCancelButtonTitle = source.cameraTopBarCancelButtonTitle;
        }
        if (source.cameraTopBarTitle !== undefined) {
            this.cameraTopBarTitle = source.cameraTopBarTitle;
        }
        if (source.cameraTopGuidance !== undefined) {
            this.cameraTopGuidance = source.cameraTopGuidance;
        }
        if (source.cameraUserGuidanceStart !== undefined) {
            this.cameraUserGuidanceStart = source.cameraUserGuidanceStart;
        }
        if (source.cameraUserGuidanceNoDocumentFound !== undefined) {
            this.cameraUserGuidanceNoDocumentFound = source.cameraUserGuidanceNoDocumentFound;
        }
        if (source.cameraUserGuidanceBadAspectRatio !== undefined) {
            this.cameraUserGuidanceBadAspectRatio = source.cameraUserGuidanceBadAspectRatio;
        }
        if (source.cameraUserGuidanceOrientationMismatch !== undefined) {
            this.cameraUserGuidanceOrientationMismatch = source.cameraUserGuidanceOrientationMismatch;
        }
        if (source.cameraUserGuidanceBadAngles !== undefined) {
            this.cameraUserGuidanceBadAngles = source.cameraUserGuidanceBadAngles;
        }
        if (source.cameraUserGuidanceTooNoisy !== undefined) {
            this.cameraUserGuidanceTooNoisy = source.cameraUserGuidanceTooNoisy;
        }
        if (source.cameraUserGuidanceTextHintOffCenter !== undefined) {
            this.cameraUserGuidanceTextHintOffCenter = source.cameraUserGuidanceTextHintOffCenter;
        }
        if (source.cameraUserGuidanceTooSmall !== undefined) {
            this.cameraUserGuidanceTooSmall = source.cameraUserGuidanceTooSmall;
        }
        if (source.cameraUserGuidanceTooDark !== undefined) {
            this.cameraUserGuidanceTooDark = source.cameraUserGuidanceTooDark;
        }
        if (source.cameraUserGuidanceEnergySaveMode !== undefined) {
            this.cameraUserGuidanceEnergySaveMode = source.cameraUserGuidanceEnergySaveMode;
        }
        if (source.cameraUserGuidanceReadyToCapture !== undefined) {
            this.cameraUserGuidanceReadyToCapture = source.cameraUserGuidanceReadyToCapture;
        }
        if (source.cameraUserGuidanceReadyToCaptureManual !== undefined) {
            this.cameraUserGuidanceReadyToCaptureManual = source.cameraUserGuidanceReadyToCaptureManual;
        }
        if (source.cameraImportButtonTitle !== undefined) {
            this.cameraImportButtonTitle = source.cameraImportButtonTitle;
        }
        if (source.cameraTorchOnButtonTitle !== undefined) {
            this.cameraTorchOnButtonTitle = source.cameraTorchOnButtonTitle;
        }
        if (source.cameraTorchOffButtonTitle !== undefined) {
            this.cameraTorchOffButtonTitle = source.cameraTorchOffButtonTitle;
        }
        if (source.cameraAutoSnapButtonTitle !== undefined) {
            this.cameraAutoSnapButtonTitle = source.cameraAutoSnapButtonTitle;
        }
        if (source.cameraManualSnapButtonTitle !== undefined) {
            this.cameraManualSnapButtonTitle = source.cameraManualSnapButtonTitle;
        }
        if (source.cameraPreviewButtonTitle !== undefined) {
            this.cameraPreviewButtonTitle = source.cameraPreviewButtonTitle;
        }
        if (source.cameraIntroDoneButton !== undefined) {
            this.cameraIntroDoneButton = source.cameraIntroDoneButton;
        }
        if (source.cameraIntroTitle !== undefined) {
            this.cameraIntroTitle = source.cameraIntroTitle;
        }
        if (source.cameraIntroSubtitle !== undefined) {
            this.cameraIntroSubtitle = source.cameraIntroSubtitle;
        }
        if (source.cameraIntroItem1 !== undefined) {
            this.cameraIntroItem1 = source.cameraIntroItem1;
        }
        if (source.cameraIntroItem2 !== undefined) {
            this.cameraIntroItem2 = source.cameraIntroItem2;
        }
        if (source.cameraIntroItem3 !== undefined) {
            this.cameraIntroItem3 = source.cameraIntroItem3;
        }
        if (source.cameraIntroItem4 !== undefined) {
            this.cameraIntroItem4 = source.cameraIntroItem4;
        }
        if (source.cameraProgressOverlayTitle !== undefined) {
            this.cameraProgressOverlayTitle = source.cameraProgressOverlayTitle;
        }
        if (source.cameraCancelAlertTitle !== undefined) {
            this.cameraCancelAlertTitle = source.cameraCancelAlertTitle;
        }
        if (source.cameraCancelAlertSubtitle !== undefined) {
            this.cameraCancelAlertSubtitle = source.cameraCancelAlertSubtitle;
        }
        if (source.cameraCancelNoButtonTitle !== undefined) {
            this.cameraCancelNoButtonTitle = source.cameraCancelNoButtonTitle;
        }
        if (source.cameraCancelYesButtonTitle !== undefined) {
            this.cameraCancelYesButtonTitle = source.cameraCancelYesButtonTitle;
        }
        if (source.cameraLimitReachedAlertTitle !== undefined) {
            this.cameraLimitReachedAlertTitle = source.cameraLimitReachedAlertTitle;
        }
        if (source.cameraLimitReachedAlertSubtitle !== undefined) {
            this.cameraLimitReachedAlertSubtitle = source.cameraLimitReachedAlertSubtitle;
        }
        if (source.cameraLimitReachedOkButtonTitle !== undefined) {
            this.cameraLimitReachedOkButtonTitle = source.cameraLimitReachedOkButtonTitle;
        }
        if (source.acknowledgementScreenBadDocumentHint !== undefined) {
            this.acknowledgementScreenBadDocumentHint = source.acknowledgementScreenBadDocumentHint;
        }
        if (source.acknowledgementRetakeButtonTitle !== undefined) {
            this.acknowledgementRetakeButtonTitle = source.acknowledgementRetakeButtonTitle;
        }
        if (source.acknowledgementAcceptButtonTitle !== undefined) {
            this.acknowledgementAcceptButtonTitle = source.acknowledgementAcceptButtonTitle;
        }
        if (source.reviewScreenTitle !== undefined) {
            this.reviewScreenTitle = source.reviewScreenTitle;
        }
        if (source.reviewTopBarBackButtonTitle !== undefined) {
            this.reviewTopBarBackButtonTitle = source.reviewTopBarBackButtonTitle;
        }
        if (source.reviewScreenPageCount !== undefined) {
            this.reviewScreenPageCount = source.reviewScreenPageCount;
        }
        if (source.reviewScreenAddButtonTitle !== undefined) {
            this.reviewScreenAddButtonTitle = source.reviewScreenAddButtonTitle;
        }
        if (source.reviewScreenRetakeButtonTitle !== undefined) {
            this.reviewScreenRetakeButtonTitle = source.reviewScreenRetakeButtonTitle;
        }
        if (source.reviewScreenCropButtonTitle !== undefined) {
            this.reviewScreenCropButtonTitle = source.reviewScreenCropButtonTitle;
        }
        if (source.reviewScreenRotateButtonTitle !== undefined) {
            this.reviewScreenRotateButtonTitle = source.reviewScreenRotateButtonTitle;
        }
        if (source.reviewScreenDeleteButtonTitle !== undefined) {
            this.reviewScreenDeleteButtonTitle = source.reviewScreenDeleteButtonTitle;
        }
        if (source.reviewScreenSubmitButtonTitle !== undefined) {
            this.reviewScreenSubmitButtonTitle = source.reviewScreenSubmitButtonTitle;
        }
        if (source.reviewScreenDeleteAllButtonTitle !== undefined) {
            this.reviewScreenDeleteAllButtonTitle = source.reviewScreenDeleteAllButtonTitle;
        }
        if (source.reviewScreenReorderPagesButtonTitle !== undefined) {
            this.reviewScreenReorderPagesButtonTitle = source.reviewScreenReorderPagesButtonTitle;
        }
        if (source.zoomOverlayCancelButtonText !== undefined) {
            this.zoomOverlayCancelButtonText = source.zoomOverlayCancelButtonText;
        }
        if (source.reviewDeletePageAlertTitle !== undefined) {
            this.reviewDeletePageAlertTitle = source.reviewDeletePageAlertTitle;
        }
        if (source.reviewDeleteAllPagesAlertTitle !== undefined) {
            this.reviewDeleteAllPagesAlertTitle = source.reviewDeleteAllPagesAlertTitle;
        }
        if (source.reviewDeletePageAlertSubTitle !== undefined) {
            this.reviewDeletePageAlertSubTitle = source.reviewDeletePageAlertSubTitle;
        }
        if (source.reviewDeleteAllPagesAlertSubtitle !== undefined) {
            this.reviewDeleteAllPagesAlertSubtitle = source.reviewDeleteAllPagesAlertSubtitle;
        }
        if (source.reviewDeletePageAlertConfirmButtonTitle !== undefined) {
            this.reviewDeletePageAlertConfirmButtonTitle = source.reviewDeletePageAlertConfirmButtonTitle;
        }
        if (source.reviewDeleteAllPagesAlertDeleteButtonTitle !== undefined) {
            this.reviewDeleteAllPagesAlertDeleteButtonTitle = source.reviewDeleteAllPagesAlertDeleteButtonTitle;
        }
        if (source.reviewDeletePageAlertDeleteRetakeButtonTitle !== undefined) {
            this.reviewDeletePageAlertDeleteRetakeButtonTitle = source.reviewDeletePageAlertDeleteRetakeButtonTitle;
        }
        if (source.reviewDeletePageAlertCancelButtonTitle !== undefined) {
            this.reviewDeletePageAlertCancelButtonTitle = source.reviewDeletePageAlertCancelButtonTitle;
        }
        if (source.reviewDeleteAllPagesAlertCancelButtonTitle !== undefined) {
            this.reviewDeleteAllPagesAlertCancelButtonTitle = source.reviewDeleteAllPagesAlertCancelButtonTitle;
        }
        if (source.acknowledgementTitle !== undefined) {
            this.acknowledgementTitle = source.acknowledgementTitle;
        }
        if (source.reorderPageTitle !== undefined) {
            this.reorderPageTitle = source.reorderPageTitle;
        }
        if (source.reorderPageGuidanceTitle !== undefined) {
            this.reorderPageGuidanceTitle = source.reorderPageGuidanceTitle;
        }
        if (source.reorderPageText !== undefined) {
            this.reorderPageText = source.reorderPageText;
        }
        if (source.reorderTopBarConfirmButtonTitle !== undefined) {
            this.reorderTopBarConfirmButtonTitle = source.reorderTopBarConfirmButtonTitle;
        }
        if (source.reorderTopBarCancelButtonTitle !== undefined) {
            this.reorderTopBarCancelButtonTitle = source.reorderTopBarCancelButtonTitle;
        }
        if (source.croppingTopBarConfirmButtonTitle !== undefined) {
            this.croppingTopBarConfirmButtonTitle = source.croppingTopBarConfirmButtonTitle;
        }
        if (source.croppingTopBarCancelButtonTitle !== undefined) {
            this.croppingTopBarCancelButtonTitle = source.croppingTopBarCancelButtonTitle;
        }
        if (source.croppingDetectButtonTitle !== undefined) {
            this.croppingDetectButtonTitle = source.croppingDetectButtonTitle;
        }
        if (source.croppingRotateButtonTitle !== undefined) {
            this.croppingRotateButtonTitle = source.croppingRotateButtonTitle;
        }
        if (source.croppingResetButtonTitle !== undefined) {
            this.croppingResetButtonTitle = source.croppingResetButtonTitle;
        }
        if (source.croppingScreenTitle !== undefined) {
            this.croppingScreenTitle = source.croppingScreenTitle;
        }
        if (source.accessibilityDescriptionCameraTopBarIntroButton !== undefined) {
            this.accessibilityDescriptionCameraTopBarIntroButton = source.accessibilityDescriptionCameraTopBarIntroButton;
        }
        if (source.accessibilityDescriptionCameraTopBarCancelButton !== undefined) {
            this.accessibilityDescriptionCameraTopBarCancelButton = source.accessibilityDescriptionCameraTopBarCancelButton;
        }
        if (source.accessibilityDescriptionCameraImportButton !== undefined) {
            this.accessibilityDescriptionCameraImportButton = source.accessibilityDescriptionCameraImportButton;
        }
        if (source.accessibilityDescriptionCameraTorchOnButton !== undefined) {
            this.accessibilityDescriptionCameraTorchOnButton = source.accessibilityDescriptionCameraTorchOnButton;
        }
        if (source.accessibilityDescriptionCameraTorchOffButton !== undefined) {
            this.accessibilityDescriptionCameraTorchOffButton = source.accessibilityDescriptionCameraTorchOffButton;
        }
        if (source.accessibilityDescriptionCameraShutterButton !== undefined) {
            this.accessibilityDescriptionCameraShutterButton = source.accessibilityDescriptionCameraShutterButton;
        }
        if (source.accessibilityDescriptionCameraAutoSnapButton !== undefined) {
            this.accessibilityDescriptionCameraAutoSnapButton = source.accessibilityDescriptionCameraAutoSnapButton;
        }
        if (source.accessibilityDescriptionCameraManualSnapButton !== undefined) {
            this.accessibilityDescriptionCameraManualSnapButton = source.accessibilityDescriptionCameraManualSnapButton;
        }
        if (source.accessibilityDescriptionCameraPreviewButton !== undefined) {
            this.accessibilityDescriptionCameraPreviewButton = source.accessibilityDescriptionCameraPreviewButton;
        }
        if (source.accessibilityDescriptionCameraIntroDoneButton !== undefined) {
            this.accessibilityDescriptionCameraIntroDoneButton = source.accessibilityDescriptionCameraIntroDoneButton;
        }
        if (source.accessibilityDescriptionAcknowledgementRetakeButton !== undefined) {
            this.accessibilityDescriptionAcknowledgementRetakeButton =
                source.accessibilityDescriptionAcknowledgementRetakeButton;
        }
        if (source.accessibilityDescriptionAcknowledgementAcceptButton !== undefined) {
            this.accessibilityDescriptionAcknowledgementAcceptButton =
                source.accessibilityDescriptionAcknowledgementAcceptButton;
        }
        if (source.accessibilityDescriptionCroppingTopBarConfirmButton !== undefined) {
            this.accessibilityDescriptionCroppingTopBarConfirmButton =
                source.accessibilityDescriptionCroppingTopBarConfirmButton;
        }
        if (source.accessibilityDescriptionCroppingTopBarCancelButton !== undefined) {
            this.accessibilityDescriptionCroppingTopBarCancelButton =
                source.accessibilityDescriptionCroppingTopBarCancelButton;
        }
        if (source.accessibilityDescriptionCroppingDetectButton !== undefined) {
            this.accessibilityDescriptionCroppingDetectButton = source.accessibilityDescriptionCroppingDetectButton;
        }
        if (source.accessibilityDescriptionCroppingRotateButton !== undefined) {
            this.accessibilityDescriptionCroppingRotateButton = source.accessibilityDescriptionCroppingRotateButton;
        }
        if (source.accessibilityDescriptionCroppingResetButton !== undefined) {
            this.accessibilityDescriptionCroppingResetButton = source.accessibilityDescriptionCroppingResetButton;
        }
        if (source.accessibilityDescriptionReorderTopBarConfirmButton !== undefined) {
            this.accessibilityDescriptionReorderTopBarConfirmButton =
                source.accessibilityDescriptionReorderTopBarConfirmButton;
        }
        if (source.accessibilityDescriptionReorderTopBarCancelButton !== undefined) {
            this.accessibilityDescriptionReorderTopBarCancelButton = source.accessibilityDescriptionReorderTopBarCancelButton;
        }
        if (source.accessibilityDescriptionReviewNextPageButton !== undefined) {
            this.accessibilityDescriptionReviewNextPageButton = source.accessibilityDescriptionReviewNextPageButton;
        }
        if (source.accessibilityDescriptionReviewPreviousPageButton !== undefined) {
            this.accessibilityDescriptionReviewPreviousPageButton = source.accessibilityDescriptionReviewPreviousPageButton;
        }
        if (source.accessibilityDescriptionReviewAddButton !== undefined) {
            this.accessibilityDescriptionReviewAddButton = source.accessibilityDescriptionReviewAddButton;
        }
        if (source.accessibilityDescriptionReviewRetakeButton !== undefined) {
            this.accessibilityDescriptionReviewRetakeButton = source.accessibilityDescriptionReviewRetakeButton;
        }
        if (source.accessibilityDescriptionReviewCropButton !== undefined) {
            this.accessibilityDescriptionReviewCropButton = source.accessibilityDescriptionReviewCropButton;
        }
        if (source.accessibilityDescriptionReviewRotateButton !== undefined) {
            this.accessibilityDescriptionReviewRotateButton = source.accessibilityDescriptionReviewRotateButton;
        }
        if (source.accessibilityDescriptionReviewDeleteButton !== undefined) {
            this.accessibilityDescriptionReviewDeleteButton = source.accessibilityDescriptionReviewDeleteButton;
        }
        if (source.accessibilityDescriptionReviewSubmitButton !== undefined) {
            this.accessibilityDescriptionReviewSubmitButton = source.accessibilityDescriptionReviewSubmitButton;
        }
        if (source.accessibilityDescriptionReviewMoreButton !== undefined) {
            this.accessibilityDescriptionReviewMoreButton = source.accessibilityDescriptionReviewMoreButton;
        }
        if (source.accessibilityDescriptionReviewDeleteAllButton !== undefined) {
            this.accessibilityDescriptionReviewDeleteAllButton = source.accessibilityDescriptionReviewDeleteAllButton;
        }
        if (source.accessibilityDescriptionReviewReorderPagesButton !== undefined) {
            this.accessibilityDescriptionReviewReorderPagesButton = source.accessibilityDescriptionReviewReorderPagesButton;
        }
        if (source.accessibilityDescriptionZoomOverlayCancelButton !== undefined) {
            this.accessibilityDescriptionZoomOverlayCancelButton = source.accessibilityDescriptionZoomOverlayCancelButton;
        }
        if (source.accessibilityDescriptionReviewZoomButton !== undefined) {
            this.accessibilityDescriptionReviewZoomButton = source.accessibilityDescriptionReviewZoomButton;
        }
        if (source.accessibilityDescriptionReviewTopBarBackButton !== undefined) {
            this.accessibilityDescriptionReviewTopBarBackButton = source.accessibilityDescriptionReviewTopBarBackButton;
        }
        if (source.accessibilityDescriptionReviewDeletePageAlertConfirmButton !== undefined) {
            this.accessibilityDescriptionReviewDeletePageAlertConfirmButton =
                source.accessibilityDescriptionReviewDeletePageAlertConfirmButton;
        }
        if (source.accessibilityDescriptionReviewDeleteAllPagesAlertDeleteButton !== undefined) {
            this.accessibilityDescriptionReviewDeleteAllPagesAlertDeleteButton =
                source.accessibilityDescriptionReviewDeleteAllPagesAlertDeleteButton;
        }
        if (source.accessibilityDescriptionReviewDeletePageAlertDeleteRetakeButton !== undefined) {
            this.accessibilityDescriptionReviewDeletePageAlertDeleteRetakeButton =
                source.accessibilityDescriptionReviewDeletePageAlertDeleteRetakeButton;
        }
        if (source.accessibilityDescriptionReviewDeletePageAlertCancelButton !== undefined) {
            this.accessibilityDescriptionReviewDeletePageAlertCancelButton =
                source.accessibilityDescriptionReviewDeletePageAlertCancelButton;
        }
        if (source.accessibilityDescriptionReviewDeleteAllPagesAlertCancelButton !== undefined) {
            this.accessibilityDescriptionReviewDeleteAllPagesAlertCancelButton =
                source.accessibilityDescriptionReviewDeleteAllPagesAlertCancelButton;
        }
        if (source.accessibilityDescriptionCameraLimitReachedOkButton !== undefined) {
            this.accessibilityDescriptionCameraLimitReachedOkButton =
                source.accessibilityDescriptionCameraLimitReachedOkButton;
        }
        if (source.accessibilityDescriptionCameraCancelYesButton !== undefined) {
            this.accessibilityDescriptionCameraCancelYesButton = source.accessibilityDescriptionCameraCancelYesButton;
        }
        if (source.accessibilityDescriptionCameraCancelNoButton !== undefined) {
            this.accessibilityDescriptionCameraCancelNoButton = source.accessibilityDescriptionCameraCancelNoButton;
        }
        if (source.cameraPermissionEnableCameraTitle !== undefined) {
            this.cameraPermissionEnableCameraTitle = source.cameraPermissionEnableCameraTitle;
        }
        if (source.cameraPermissionEnableCameraExplanation !== undefined) {
            this.cameraPermissionEnableCameraExplanation = source.cameraPermissionEnableCameraExplanation;
        }
        if (source.cameraPermissionEnableCameraButton !== undefined) {
            this.cameraPermissionEnableCameraButton = source.cameraPermissionEnableCameraButton;
        }
        if (source.cameraPermissionCloseButton !== undefined) {
            this.cameraPermissionCloseButton = source.cameraPermissionCloseButton;
        }
        if (source.accessibilityDescriptionCameraPermissionEnableCameraButton !== undefined) {
            this.accessibilityDescriptionCameraPermissionEnableCameraButton =
                source.accessibilityDescriptionCameraPermissionEnableCameraButton;
        }
        if (source.accessibilityDescriptionCameraPermissionCloseButton !== undefined) {
            this.accessibilityDescriptionCameraPermissionCloseButton =
                source.accessibilityDescriptionCameraPermissionCloseButton;
        }
    }
}
//# sourceMappingURL=DocumentScannerTextLocalization.js.map